import { render, staticRenderFns } from "./ApproverSettingsView.vue?vue&type=template&id=f616e7d6&"
import script from "./ApproverSettingsView.vue?vue&type=script&lang=js&"
export * from "./ApproverSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports